<header>
  <nav class="header__wrap">
    <a class="nav-link navbar-brand" routerLink="/#" [title]="'HEADER.HOME' | translate">
      <img class="w-100" [alt]="'HEADER.HOME' | translate" [src]="logoHeaderUrl" />
    </a>

    <button class="nav-toggle" [attr.aria-label]="'HEADER.OPEN_MENU' | translate" (click)="toggleMobileNav()">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <ul>
      <li class="nav-item" *ngIf="isLoggedIn">
        <a href="/perfil" class="iniciar" routerLink="perfil" routerLinkActive="activo"></a>
      </li>

      <li class="nav-item" *ngIf="showModeratorBoard">
        <a href="/mod" class="iniciar" routerLinkActive="activo" routerLink="mod">{{ 'HEADER.MODERATOR_BOARD' |
          translate }}</a>
      </li>
      <!--
            <li class="nav-item">
                <a href="/user" class="iniciar" routerLinkActive="activo" *ngIf="isLoggedIn" routerLink="user">Otra cosa</a>
            </li>
            -->
    </ul>

    <ul class="d-flex flex-wrap mt-3 nav-secondary" [class.nav-open]="mobileNavOpen">
      <li>
        <app-language-switcher></app-language-switcher>
      </li>
      <li>
        <a href="/#/perfil?action=32" class="header-notif-link"><mat-icon style="width: 30px; margin-right: 10px; " class="badgeNearCustom header-notif-icon"
            [matBadgeHidden]="totalNotificaciones==0" [matBadge]="totalNotificaciones" matBadgeColor="warn"
            matBadgeOverlap="fa-twitter-square" matBadgeSize="small">notifications</mat-icon></a>
      </li>
      <li>
        <a (click)="navegaSeccion('/inicio#region-tramites')" class="buscar">
          <span class="material-icons header-icon-muted">search</span>
        </a>
      </li>
      <!-- Quitamos el registro sin Cl@ve a petición del usuario
       <li class="nav-item" *ngIf="!isLoggedIn">
        <a routerLink="/register" routerLinkActive="activo" class="iniciar"
          >{{ 'HEADER.REGISTER' | translate }}</a
        >
      </li>-->
      <li *ngIf="!isLoggedIn">
        <a class="nav-link dropdown-toggle btn registrar" href="#" id="navbarDropdown" role="button"
          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ 'HEADER.IDENTIFY' | translate }}</a>
        <!--<a (click)="reload()" routerLink="/login" routerLinkActive="activo" class="registrar">{{ 'HEADER.IDENTIFY' | translate }}</a>-->

        <div class="dropdown-menu">
          <div class="registration-title mb-2">
            {{ 'HEADER.ACCESS_METHOD' | translate }}
          </div>
          <div class="accordion" id="accordionExample">
            <div class="p-2">


              <!-- Se comenta para eliminar la opción de inicio de sesión con usuario y contraseña -->
              <!-- <a
                (click)="reload()"
                routerLink="/login"
                routerLinkActive="activo"
                class="link-registration d-flex justify-content-between align-items-baseline"
                ><span>{{ 'HEADER.EMAIL_PASSWORD' | translate }}</span
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-arrow-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </a> -->


            </div>
            <div class="p-2" *ngIf="loginType === 'both' || loginType === 'clave'">
              <a (click)="redireccion()"
                class="link-registration d-flex justify-content-between align-items-baseline"><span>{{ 'HEADER.CLAVE' |
                  translate }} </span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-arrow-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                </svg>
              </a>
            </div>
          </div>
          <p class="cuadro-texto">
            {{ 'HEADER.AUTOFIRMA_TEXT' | translate }}
            <a href="https://firmaelectronica.gob.es/Home/Descargas.html" target="_blank">{{ 'HEADER.AUTOFIRMA_LINK' |
              translate }}</a>{{ 'HEADER.AUTOFIRMA_SUFFIX' | translate }}
          </p>
        </div>
      </li>
      <!-- <li class="nav-item">
          <a href="/profile" class="nav-link" routerLink="profile">{{ username }} asadad</a>
      </li>-->
      <li *ngIf="isLoggedIn">
        <a class="iniciar" routerLink="/perfil" routerLinkActive="activo"><i>{{ usuario.nombre }} {{ usuario.apellido1
            }}</i></a>
      </li>
      <li class="nav-item" *ngIf="isLoggedIn">
        <a href class="iniciar" (click)="logout()">{{ 'HEADER.LOGOUT' | translate }}</a>
      </li>
    </ul>
  </nav>
  <!--<nav class="navbar navbar-secondary">
    <form class="form-inline ml-auto">
      <a class="icons-redes" href="#"><i class="fab fa-facebook-square"></i></a>
            <a class="icons-redes" href="#"><i class="fab fa-twitter-square"></i></a>
            <a class="icons-redes" href="#"><i class="fab fa-instagram-square"></i></a>
    </form>
  </nav>-->
</header>